export const sections = {
  INBOX: 'inbox',
  SETTINGS: 'settings',
};
